/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JoinRequestAction } from './JoinRequestAction';
import {
    JoinRequestActionFromJSON,
    JoinRequestActionFromJSONTyped,
    JoinRequestActionToJSON,
    JoinRequestActionToJSONTyped,
} from './JoinRequestAction';

/**
 * 
 * @export
 * @interface ProcessJoinRequestsModel
 */
export interface ProcessJoinRequestsModel {
    /**
     * 
     * @type {string}
     * @memberof ProcessJoinRequestsModel
     */
    org_code: string;
    /**
     * 
     * @type {Array<JoinRequestAction>}
     * @memberof ProcessJoinRequestsModel
     */
    actions: Array<JoinRequestAction>;
}

/**
 * Check if a given object implements the ProcessJoinRequestsModel interface.
 */
export function instanceOfProcessJoinRequestsModel(value: object): value is ProcessJoinRequestsModel {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('actions' in value) || value['actions'] === undefined) return false;
    return true;
}

export function ProcessJoinRequestsModelFromJSON(json: any): ProcessJoinRequestsModel {
    return ProcessJoinRequestsModelFromJSONTyped(json, false);
}

export function ProcessJoinRequestsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessJoinRequestsModel {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'actions': ((json['actions'] as Array<any>).map(JoinRequestActionFromJSON)),
    };
}

export function ProcessJoinRequestsModelToJSON(json: any): ProcessJoinRequestsModel {
    return ProcessJoinRequestsModelToJSONTyped(json, false);
}

export function ProcessJoinRequestsModelToJSONTyped(value?: ProcessJoinRequestsModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'actions': ((value['actions'] as Array<any>).map(JoinRequestActionToJSON)),
    };
}

